import { Alert, Form, Space, Typography } from 'antd'
import React, { useCallback, useEffect, useMemo } from 'react'
import { ToolStatusMappingAPI } from 'restAPI/ToolsIntegrationAPI'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import _ from 'lodash'
import { DEFAULT_CONFIDENCE_LEVEL, FINDINGS_CONFIDENCE_OPTIONS } from './SettingStatusConstant';

const ToolConfidenceLevel = ({ toolName, handleToolConfidenceLevelChange }) => {
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();

    const fetchData = useCallback(async () => {
        try {
            const resData = await ToolStatusMappingAPI.getToolStatusMapping(toolName).promise;
            const selectedValue = _.isEmpty(resData) ? DEFAULT_CONFIDENCE_LEVEL : resData.config.confidenceLevel
            form.setFieldsValue({ confidenceLevel: selectedValue })
            handleToolConfidenceLevelChange(selectedValue);
        } catch (err) {
            console.error(err)
        }
    }, [toolName, form, handleToolConfidenceLevelChange])

    useEffect(() => {
        fetchData();
    }, [globalFilterHash, fetchData])


    const fields = useMemo(() => [{
        name: "confidenceLevel",
        label: <Typography.Text>Select the confidence level of findings to be ingested into ArmorCode</Typography.Text>,
        placeholder: <Typography.Text>Select confidence level</Typography.Text>,
        type: FieldTypes.MULTI_SELECT,
        options:  FINDINGS_CONFIDENCE_OPTIONS,
        colSpan: 18,
        props: {
            allowClear: true
        }
    }], [])


    return (
        <Space direction="vertical" className="m-b-m">
            <Alert
                description={
                    <Form
                        form={form}
                        style={{ minWidth: 600 }}
                        layout="vertical"
                        onValuesChange={(values) => {
                            handleToolConfidenceLevelChange(values.confidenceLevel)
                        }}
                    >
                        {generateFormFields(fields)}
                    </Form>
                }
            />
        </Space>
    )
}

export default ToolConfidenceLevel;
